module.exports = __webpack_public_path__ + "static/media/worldwide.8c84a8ad.svg";